import type { Product } from "../types";

// Rational accessory recommendations are derived from each accessory's
// `compatible_with` characteristic (a plain-text list of unit line/size
// names, e.g. "iCombi Pro, iCombi Classic" or "iVario Pro L, iVario Pro XL")
// rather than a hand-maintained per-unit mapping — the naming is consistent
// between unit product names and accessory compatibility strings (both use
// "iCombi Pro" / "iCombi Classic" / "iVario Pro L" etc. verbatim), so
// substring matching is accurate and stays in sync automatically as either
// catalog changes.
const IVARIO_SIZE_KEYS = ["iVario Pro XL", "iVario Pro L", "iVario Pro 2-S", "iVario 2-XS"];

function getCompatibilityKey(product: Product): string | null {
  if (product.brand !== "Rational" || product.subcategory === "Аксессуары") return null;

  if (product.subcategory === "Сковороды опрокидываемые") {
    return IVARIO_SIZE_KEYS.find((key) => product.name.includes(key)) ?? null;
  }

  if (product.subcategory === "Пароконвектоматы") {
    // Combi-Duo kits are built from iCombi Pro/Classic units and take the
    // same accessory range as the base unit they join.
    if (product.name.includes("iCombi Classic")) return "iCombi Classic";
    return "iCombi Pro";
  }

  return null;
}

export function getRecommendedAccessories(product: Product, allProducts: Product[]): Product[] {
  const key = getCompatibilityKey(product);
  if (!key) return [];

  return allProducts.filter(
    (p) =>
      p.subcategory === "Аксессуары" &&
      typeof p.characteristics?.compatible_with === "string" &&
      p.characteristics.compatible_with.includes(key)
  );
}
